"use client"

import { useEffect, useRef, type ReactNode } from "react"
import { ChevronDown } from "lucide-react"

import { cn } from "../lib/cn"

interface FormSectionProps {
  title: string
  summary?: ReactNode
  children: ReactNode
  defaultOpen?: boolean
  className?: string
}

export function FormSection({ title, summary, children, defaultOpen = false, className }: FormSectionProps) {
  const section = useRef<HTMLDetailsElement>(null)
  useEffect(() => {
    if (defaultOpen && section.current) section.current.open = true
  }, [defaultOpen])
  return (
    <details ref={section} data-slot="form-section" className={cn("group rounded-md border border-border bg-card", className)}>
      <summary className="flex cursor-pointer list-none items-center justify-between gap-3 px-3 py-2 text-sm font-medium text-foreground marker:hidden [&::-webkit-details-marker]:hidden">
        <span className="flex min-w-0 items-center gap-2">{title}{summary && <span className="text-xs font-normal text-muted-foreground">{summary}</span>}</span>
        <ChevronDown aria-hidden="true" className="size-4 shrink-0 text-muted-foreground transition-transform group-open:rotate-180" />
      </summary>
      <div className="border-t border-border px-3 py-3">{children}</div>
    </details>
  )
}
